module.exports = __webpack_public_path__ + "img/psd.b1973c7.svg";